import { getMantenedores } from "../../../shared/helpers/api/apiCall";

const fieldMapping = {
    "banco": "banco",
    "tipo_cuenta": "tipo_cuenta",
    "empresa": "sigla",
    "tipo_flota": "flota",
    "tms": "tms",
    "conductores": "nombre",
    "centro_despacho": "centroDespacho",
    "tipo_vehiculo": "tipo",
    "tipo_documento": "documento"
};

export const selectJsonFormatter = async (type, user) => {
    try {
        const json = await getMantenedores(type, user);
        const mappingField = fieldMapping[type];

        if (!mappingField) {
            throw new Error(`No mapping found for type: ${type}`);
        }

        const items = json[type];
        if (!items) {
            throw new Error(`No items found for type: ${type}`);
        }

        const formattedData = items.map(item => {
            return {
                id: item.id,
                nombre: item[mappingField]
            };
        });

        // console.log(`Formatted data for type: ${type}`, formattedData);
        return formattedData
    } catch (error) {
        console.error(`Error fetching or formatting data for type: ${type}`, error);
        return [];
    }
};